import React, { useEffect, useRef, useState } from "react";
import { IMAGES } from "@/lib/site";
import { useMotionQuery } from "@/lib/responsive";

export const HeroMedia = () => {
  const enabled = useMotionQuery("(prefers-reduced-motion: no-preference)");
  const video = useRef(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const element = video.current;
    if (!enabled || failed || !element) return undefined;
    let visible = true;
    const sync = () => {
      if (!visible || document.hidden) element.pause();
      else element.play().catch(() => setFailed(true));
    };
    const observer = new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; sync(); });
    observer.observe(element);
    document.addEventListener("visibilitychange", sync);
    return () => { element.pause(); observer.disconnect(); document.removeEventListener("visibilitychange", sync); };
  }, [enabled, failed]);

  return (
    <>
      <img src={IMAGES.hero} alt="" aria-hidden="true" fetchPriority="high" className="hero-poster absolute inset-0 w-full h-full object-cover" />
      {enabled && !failed && (
        <video ref={video} className="absolute inset-0 w-full h-full object-cover" autoPlay muted loop playsInline preload="metadata" poster={IMAGES.hero} aria-hidden="true" onError={() => setFailed(true)}>
          <source src={`${process.env.PUBLIC_URL}/media/hero.mp4`} type="video/mp4" onError={() => setFailed(true)} />
        </video>
      )}
    </>
  );
};
